module.exports = __webpack_public_path__ + "media/images/vod_icons/bft-7c43643df9baad4c88069db5e6a82b07.svg";